import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import {
  screen,
  screenOpen,
  addSectionToWrapper,
  editSectionId,
  isBuilder,
} from '@/store/builder/store'

import Classnames from 'classnames'

// components
import Title from '@/components/onepager/sections/Title'
import Section from '@/components/onepager/Section'

function Wrapper({ id, contentID, sectionData }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getAddSectionWrapperID, setAddSectionWrapperID] =
    useRecoilState(addSectionToWrapper)

  const openSectionAdd = (rowIndex, colIndex) => {
    setAddSectionWrapperID({
      rowIndex: rowIndex,
      colIndex: colIndex,
      wrapperId: id,
    })
    setScreen('addsection')
    setScreenOpen(true)
  }

  const openEditor = () => {
    if (isBuilderApp) {
      setScreen('editsection')
      setScreenOpen(true)
      setEditSectionId(id)
    }
  }

  return (
    <div className="flex-col flex h-full sectionWrapperEntire">
      <Title id={id} title={sectionData.title} prompt={sectionData.prompt} />

      <div className="boxBody boxBodyWrapper h-full flex-grow">
        {sectionData.data.rows.length == 0 && (
          <div
            onClick={openEditor}
            className="border-2 border-dashed cursor-pointer  rounded border-gray-300 hover:bg-gray-50 flex flex-col justify-center items-center h-full"
          >
            <span className="text-sm font-medium text-gray-400">
              ADD INNER WRAPPER ROWS
            </span>
          </div>
        )}

        {sectionData.data.rows.length > 0 && (
          <div
            className={Classnames(
              'sectionWrapper shadow-lg h-full md:grid md:grid-cols-1 md:gap-0',
              {
                sectionWrapperBlue: sectionData.data.color.id == 'blue',
                sectionWrapperGreen: sectionData.data.color.id == 'green',
                sectionWrapperRed: sectionData.data.color.id == 'red',
                sectionWrapperYellow: sectionData.data.color.id == 'yellow',
                sectionWrapperPurple: sectionData.data.color.id == 'purple',
                sectionWrapperGray: sectionData.data.color.id == 'gray',
              }
            )}
          >
            {sectionData.data.rows.map((row, rowIndex) => (
              <div
                key={row.id}
                className="h-full sectionWrapperSection relative"
              >
                <div
                  className={`md:grid md:grid-cols-${row.cols} md:gap-0 h-full`}
                >
                  {row.sections.map((section, colIndex) => (
                    <div
                      key={'innersection-section-' + colIndex}
                      className="h-full sectionWrapperSectionInner"
                    >
                      {section.sectionID == 'none' && (
                        <div className="p-5 h-full sectionWrapperBox">
                          {isBuilderApp && (
                            <div
                              onClick={() => {
                                openSectionAdd(rowIndex, colIndex)
                              }}
                              className="h-full bg-black bg-opacity-10 border-2 border-dashed border-black border-opacity-10 rounded flex flex-col items-center justify-center text-lg font-medium cursor-pointer "
                            >
                              <div className="py-3 px-4 my-3 bg-black hover:bg-blue-600 rounded text-sm text-white">
                                Add Section
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {section.sectionID !== 'none' && (
                        <div className="sectionWrapperBox h-full">
                          <Section id={section.sectionID} wrapperId={id} />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Wrapper
